import { useState, useEffect, useCallback } from 'react';
import { CarouselApi } from 'types/sharedComponents';

const useCarousel = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) return;

    const handleSelect = () => {
      setCurrent(api.selectedScrollSnap());

      const autoplay = api?.plugins()?.autoplay;
      if (autoplay) {
        // Resume autoplay when new slide is selected
        autoplay.reset();
        autoplay.play();
      }
    };

    api.on('select', handleSelect);

    return () => {
      api.off('select', handleSelect);
    };
  }, [api]);

  const scrollTo = useCallback(
    (index: number) => {
      api?.scrollTo(index);
    },
    [api],
  );

  return { current, scrollTo, setApi };
};

export default useCarousel;
